/*
 * Smooth open/close for the collapsible-content accordion (FAQ page).
 *
 * Dawn renders each item as a native <details>, which toggles instantly —
 * the content pops in with no transition. Live animates the panel over
 * ~300ms (it uses `transition: grid-template-rows 0.3s`), so we match that
 * duration here.
 *
 * A CSS-only version isn't reliable: the browser hides the children of a
 * closed <details>, so the collapse transition never gets a chance to run.
 * Instead we intercept the summary click, animate the panel height, and
 * only remove the `open` attribute once the close animation has finished.
 */
(function () {
  var DURATION = 300;

  function setup(details) {
    if (details.dataset.smoothAccordion === 'true') return;

    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    details.dataset.smoothAccordion = 'true';
    var animating = false;

    summary.addEventListener('click', function (event) {
      // Respect the OS setting at click time, not just at load.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      event.preventDefault();
      if (animating) return;
      animating = true;

      var isOpen = details.hasAttribute('open');
      var from = isOpen ? content.scrollHeight : 0;
      var to = isOpen ? 0 : null; // measured after `open` is set

      if (!isOpen) details.setAttribute('open', '');
      if (to === null) to = content.scrollHeight;

      content.style.overflow = 'hidden';
      content.style.height = from + 'px';

      requestAnimationFrame(function () {
        content.style.transition = 'height ' + DURATION + 'ms ease';
        content.style.height = to + 'px';
      });

      window.setTimeout(function () {
        if (isOpen) details.removeAttribute('open');
        content.style.transition = '';
        content.style.height = '';
        content.style.overflow = '';
        animating = false;
      }, DURATION);
    });
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.collapsible-content .accordion details')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-bind when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
